import React from 'react';
import { DefaultvendorFormData } from '.';
import useVendorContext from 'contexts/vendor.context';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { PLUS_ICON } from 'assets/icons/siderbar-icons';
import { DeleteIcon } from 'cokitchen-icons';
import EditableInput from 'components/base/editable-input';

const AddVendorDetails = () => {
  const { vendorFormData, setVendorFormData, bankList } = useVendorContext();

  const handleChange = (field: string, value: string, index: number) => {
    setVendorFormData(
      vendorFormData.map((itm, i) => (i === index ? { ...itm, [field]: value } : itm))
    );
  };

  const addVendor = () => {
    setVendorFormData([...vendorFormData, { ...DefaultvendorFormData }]);
  };

  const removeVendor = (index: number) => {
    setVendorFormData(vendorFormData.filter((_, i) => index !== i));
  };

  const daysArray: { id: string; name: string }[] = [];

  for (let i = 1; i <= 30; i++) {
    daysArray.push({
      id: i.toString(),
      name: `${i} day${i > 1 ? 's' : ''}`
    });
  }

  const VENDOR_HEADERS = [
    'Vendor Name',
    'Phone Number',
    'Bank Name',
    'Account Number',
    'Account Name',
    'Payment Period',
    'Actions'
  ];

  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Provide vendor details</h3>
      </div>

      <Table headers={VENDOR_HEADERS}>
        {vendorFormData.map((vendor, index) => (
          <TableRow key={index} className='hover:bg-gray-50 transition-colors'>
            <TableData className='px-2 py-2 text-sm'>
              <EditableInput
                type='text'
                isEditing
                value={vendor.name}
                onChange={(e) => handleChange('name', e.target.value, index)}
                placeholder='Femite foodco ltd'
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <EditableInput
                isEditing
                value={vendor.phone_number}
                type='number'
                onChange={(e) => handleChange('phone_number', e.target.value, index)}
                placeholder='081 476 5411'
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <SelectDropdown
                hasSearch
                placeholder='Select bank'
                value={vendor.bank_name}
                setValue={(bank) => {
                  handleChange('bank_name', bank.name, index);
                }}
                options={bankList}
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <EditableInput
                isEditing
                value={vendor.account_number}
                type='number'
                onChange={(e) => handleChange('account_number', e.target.value, index)}
                placeholder='01425671623'
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <EditableInput
                isEditing
                type='text'
                value={vendor.account_name}
                onChange={(e) => handleChange('account_name', e.target.value, index)}
                placeholder='Femite Foods & Drinks'
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <SelectDropdown
                placeholder='2 days'
                value={vendor.payment_period}
                setValue={(period) => {
                  handleChange('payment_period', period.name, index);
                }}
                options={daysArray}
              />
            </TableData>

            <TableData className='px-2 py-2 text-sm'>
              <div className='flex items-center justify-center'>
                {vendorFormData.length > 1 && (
                  <div className='cursor-pointer text-red-5' onClick={() => removeVendor(index)}>
                    <DeleteIcon />
                  </div>
                )}
              </div>
            </TableData>
          </TableRow>
        ))}
      </Table>

      <button
        onClick={addVendor}
        className='text-[#0080E5] mt-6 font-medium text-sm border border-[#E5E6E6] border-dashed rounded-[100px] px-2 py-1 flex gap-1 items-center'>
        <PLUS_ICON />
        Add another vendor
      </button>
    </div>
  );
};

export default AddVendorDetails;
